<script>
  import { onMount } from 'svelte';
  import session from '../../lib/session'
  import { slide } from 'svelte/transition';

  export let percentages;
  export let profile;

  let values = [];
  let has_init = false;
  let show = false;
  let timer;

  const get_rating_icon = rating => {
    if (rating === 'sad') return 'sentiment_very_dissatisfied';
    if (rating === 'neutral') return 'sentiment_dissatisfied';
    if (rating === 'happy') return 'sentiment_satisfied_alt';
    if (rating === 'extremely_happy') return 'sentiment_very_satisfied';
  };

  const init_rating = () => {


    values = [
      { rating: 'extremely_happy', value: !!percentages.extremely_happy ? percentages.extremely_happy : '0' },
      { rating: 'happy', value: !!percentages.happy ? percentages.happy : '0' },
      { rating: 'neutral', value: !!percentages.neutral ? percentages.neutral : '0' },
      { rating: 'sad', value: !!percentages.sad ? percentages.sad : '0'}
    ]
    has_init = true;
    timer = setTimeout(() => {
      show = true;
      clearTimeout(timer);
    }, 600);
  }

  $: if(!!percentages & !has_init) init_rating();
</script>

<div class="mdc-card center roll-out {profile._role}" style="    padding-top: 30px;
    margin-top: 8px;
    background-color: rgba(255, 255, 255, 0.6);
    padding-bottom: 46px;">
  <div style='display: flex; justify-content: center; flex-wrap: wrap;'>

    {#if show}
      <div transition:slide={{ duration: 300 }}>
        {#each values as v, index}
          <div style='display: flex; position: relative'>

            <i
              class="material-icons">
              {get_rating_icon(v.rating)}
            </i>
            <div class='rating'>
              <div class='rating__bg'></div>
              <div style={`width: ${v.value}%`}>
              <div class='rating__value'
                   class:rating_100={v.value === 100}></div>
              </div>



            </div>
            <p>{v.value}%</p>
          </div>
        {/each}
      </div>
    {/if}

  </div>

</div>



<style>
    .rating{
        width: 385px;
        height: 38px;
        margin-top: 10px;
        margin-right: 10px;
        /* margin-bottom: 15px; */
        border-radius: 5px;
        -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        -webkit-box-shadow: 0 0 4px rgb(0 0 0 / 20%);
        box-shadow: 0 0 4pxrgb(0 0 0 / 20%);
        position: relative;

    }

    .rating__value{
        position: absolute;
        left: 0;
        top: 0;
        height: 38px;
        width: inherit;
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;
        animation: progressAnimationStrike 1s linear;

    }

    .rating_100{
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    }

    .orderer .rating__value{
        background-color: var(--worker-background-color);
    }

    .worker .rating__value{
        background-color: var(--orderer-background-color);
    }

    .rating__bg{
        position: absolute;
        left: 0;
        top: 0;
        height: 38px;
        border-radius: 5px;
        width: 385px;
        background-color: white;
    }

    p{
        position: absolute;
        right: -29px;
        top: 8px;
        color: black;
        font-size: 12pt;
    }

    .material-icons{
        font-size: 23pt;
        z-index: 10;
        position: absolute;
        left: -43px;
        top: 19px;
        color: black;
    }

    @keyframes progressAnimationStrike {
        /*0%{*/
        /*    width: 0;*/
        /*}*/
        /*33%{*/
        /*    width: 0;*/
        /*}*/
        /*100%{*/
        /*    width: inherit;*/
        /*}*/
        from { width: 0 }
        to   { width: inherit }
    }

    @media (min-height: 0) and (max-height: 735px) {

        .rating, .rating__bg{
            width: 200px;
        }

        p{
            position: absolute;
            /*right: 25px !important;*/
            top: 5px;
        }

        .material-icons{
            position: absolute;
            top: 16px;
        }
    }
</style>
